import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InsuredDetailComponent } from './pages/insured-detail/insured-detail.component';
import { CustomerJourneyComponent } from './customer-journey.component';
import { ContactDetailComponent } from './pages/contact-detail/contact-detail.component';
import { RedirectBeforeGuard } from '../shared/redirect-guard/redirect-before';

const routes: Routes = [
  {
    path: '',
    component: CustomerJourneyComponent,
    canActivate: [RedirectBeforeGuard],
    children: [
      // { path: "", pathMatch: 'full', redirectTo: 'Q1' },
      { path: 'Q1', component: InsuredDetailComponent },
      { path: 'Q2', component: ContactDetailComponent }
    ]
  },
  { path: '', pathMatch: 'full', redirectTo: '', canActivate: [RedirectBeforeGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomerJourneyRoutingModule {}
